import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';

import * as _ from 'lodash';
import ProductSelector from '@/components/productSelector/ProductSelector';
import { ProductDefinition, AnimationDefinition } from '@/models/configuratorx/configuratorSchema';
import Toggle from '@/components/parts/Toggle';

import PartsColor from '@/components/partsColor/PartsColor';



@Component({
  components: {
    toggle: Toggle,
    partsColor: PartsColor,
  },
})
export default class Mode1 extends Vue {
  private _configuratorService: ConfiguratorService = undefined;


  @Inject()
  private _container: ComponentContainer;

  isYazisehpasi: boolean = true;
  seletedFoot: string = RabbitFoot.Krom;

  product: ProductDefinition;



  defHideObjects = [
    '_yyy',
  ];

  defShowObjects =  [
    'rabbitwood_mode1_govde_yyy',
    'rabbitwood_mode1_yazi_tahtali_ayak_krom_yyy',

  ];


  availableAnimations: AnimationDefinition[] = [];


  async created() {
    this.product = Store.getProductById('mode1');
    this.product.partsPalettes = _.orderBy(this.product.partsPalettes, ['order'], ['asc']);

    //this.availableAnimations =  this.product.animations as  AnimationDefinition[];
    //this.availableAnimationsChanged();

    this._configuratorService = this._container.get<ConfiguratorService>(ServiceIdentifiers.ConfiguratorService);
    await this._configuratorService.hideObjects({ objects: this.defHideObjects, operator: FilterOperators.Contains });
    await this._configuratorService.showObjects({ objects: this.defShowObjects, operator: FilterOperators.Contains });
    if (Store.state.selection) {
      Store.state.selection.parts.forEach((element) => {
        this.colorChanged(element.color,element.palette,element.id);
      });
      await this.changeFoot(Store.state.selection.foot);
      await this.changeYaziSehpasi(Store.state.selection.isYazisehpasi);

    } else {
      await  this.applyDefaultSelection();
    }

  }


  availableAnimationsChanged() {

    this.$emit('availableAnimationsChanged', this.availableAnimations);
  }



  mounted() {
    // this.configuratorService = Store.state.configuratorService;

  }

  async applyDefaultSelection() {
    const selection = new RabbitAhsapSelection();
    selection.parts = [];
    selection.foot = RabbitFoot.Krom;
    selection.isYazisehpasi = true;

    this.product.defaults.parts.forEach((element) => {
      this.colorChanged(element.color,element.palette,element.id);
      const part = new PartSelection();
      part.id = element.id;
      part.color = element.color;
      part.name = element.name;
      part.palette = element.palette;
      selection.parts.push(part);
    });

    Store.state.selection = selection;
    await this.changeFoot(RabbitFoot.Krom);
    await this.changeYaziSehpasi(true);
  }

  async colorChanged(color: any,palette: any,part: any) {

    const getPart = this.product.partsPalettes.find(x => x.part === part);
    const getPalettes = Store.state.configuratorConfig.definitions.palettes.find(x => x.id === palette);
    const getColor = getPalettes.colors.find(col => col.name === color);
    await this._configuratorService.changeAlbedoPBR({
      materials: getPart.materials,
      texture: getColor.texture,
    });
    Store.state.selection.parts.find(x => x.id === part).palette = palette;
    Store.state.selection.parts.find(x => x.id === part).color = color;
  }

  async changeFoot(foot: RabbitFoot)
  {
    await this._configuratorService.hideObjects({ objects: ['_yyy'], operator: FilterOperators.Contains });

    if (foot === RabbitFoot.Krom)
    {
      if (this.isYazisehpasi)
      {
        await this._configuratorService.showObjects({ objects: ['rabbitwood_mode1_govde_yyy', 'rabbitwood_mode1_yazi_tahtali_ayak_krom_yyy'], operator: FilterOperators.Contains });
      }
      else
      {
        await this._configuratorService.showObjects({ objects: ['rabbitwood_mode1_govde_yyy', 'rabbitwood_mode1_ayak_krom_yyy'], operator: FilterOperators.Contains });

      }

      Store.state.selection.foot = RabbitFoot.Krom;
      this.seletedFoot = RabbitFoot.Krom;

    }

    if (foot === RabbitFoot.SiyahBoyali)
    {
      if (this.isYazisehpasi)
      {
        if (this.seletedFoot === RabbitFoot.Krom)
        {
          await this._configuratorService.showObjects({ objects: ['rabbitwood_mode1_govde_yyy', 'rabbitwood_mode1_yazi_tahtali_ayak_boyali_yyy'], operator: FilterOperators.Contains });

        }
      }
      else
      {
        await this._configuratorService.showObjects({ objects: ['rabbitwood_mode1_govde_yyy', 'rabbitwood_mode1_ayak_boyali_yyy'], operator: FilterOperators.Contains });

      }
      Store.state.selection.foot = RabbitFoot.SiyahBoyali;
      this.seletedFoot = RabbitFoot.SiyahBoyali;
    }
  }

  async changeYaziSehpasi(isYazisehpasi: boolean)
  {
    await this._configuratorService.hideObjects({ objects: ['_yyy'], operator: FilterOperators.Contains });

    if (isYazisehpasi)
    {
      if (this.seletedFoot === RabbitFoot.Krom)
      {
        await this._configuratorService.showObjects({ objects: ['rabbitwood_mode1_govde_yyy', 'rabbitwood_mode1_yazi_tahtali_ayak_krom_yyy'], operator: FilterOperators.Contains });

      }
      else if (this.seletedFoot === RabbitFoot.SiyahBoyali)
      {
        await this._configuratorService.showObjects({ objects: ['rabbitwood_mode1_govde_yyy', 'rabbitwood_mode1_yazi_tahtali_ayak_boyali_yyy'], operator: FilterOperators.Contains });

      }

    }
    else
    {
      if (this.seletedFoot === RabbitFoot.Krom)
      {
        await this._configuratorService.showObjects({ objects: ['rabbitwood_mode1_govde_yyy', 'rabbitwood_mode1_ayak_krom_yyy'], operator: FilterOperators.Contains });

      }
      else if (this.seletedFoot === RabbitFoot.SiyahBoyali)
      {
        await this._configuratorService.showObjects({ objects: ['rabbitwood_mode1_govde_yyy', 'rabbitwood_mode1_ayak_boyali_yyy'], operator: FilterOperators.Contains });

      }
    }


    Store.state.selection.isYazisehpasi = isYazisehpasi;
    this.isYazisehpasi = isYazisehpasi;

  }
}





export class RabbitAhsapSelection
{
  parts: PartSelection[];
  foot: RabbitFoot;
  isYazisehpasi: boolean;
}
export class PartSelection
{
  id: string;
  palette: string;
  color: string;
  name: string;
}


enum RabbitFoot
{
  Krom = 'krom',
  GriBoyali = 'griboyali',
  SiyahBoyali = 'siyahboyali',

}



// WEBPACK FOOTER //
// ./src/components/families/rabbitwood/Mode1.ts